// extracted by mini-css-extract-plugin
export var bubble = "_2i-0";
export var container = "_2i-f";
export var contrastBorder = "_2i-g";
export var greyOut = "_2i-2";
export var initialsColor0 = "_2i-3";
export var initialsColor1 = "_2i-4";
export var initialsColor10 = "_2i-d";
export var initialsColor11 = "_2i-e";
export var initialsColor2 = "_2i-5";
export var initialsColor3 = "_2i-6";
export var initialsColor4 = "_2i-7";
export var initialsColor5 = "_2i-8";
export var initialsColor6 = "_2i-9";
export var initialsColor7 = "_2i-a";
export var initialsColor8 = "_2i-b";
export var initialsColor9 = "_2i-c";
export var initialsWrapper = "_2i-1";
export var large = "_2i-l";
export var medium = "_2i-k";
export var mediumSmall = "_2i-j";
export var mediumSmallMedium = "_2i-o";
export var micro = "_2i-h";
export var small = "_2i-i";
export var tiny = "_2i-n";
export var xTiny = "_2i-m";